// extracted by mini-css-extract-plugin
export default {"chatPanelWrapper":"chatPanel_chatPanelWrapper__QIPeJ","roomWrapper":"chatPanel_roomWrapper__0RGDY"};